<template>
  <div class="item" v-if="recipient.recipient_uuid || recipient.recipient_number"
      :class="{'active': active}">
    <div class="avatar">A</div>
    <div class="info-container" :class="!is_read ? 'bold' : ''">
      <div class="user-info">
        <p class="full-name">{{ recipient.recipient_name }}</p>
        <p class="date">{{ currentSms.date || date }}</p>
      </div>
      <div class="user-message">{{ currentSms.message || message }}</div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['uuid', 'recipient', 'index', 'lastSms'],
  data: () => ({
    message: '',
    date: '',
    is_read: true,
    last_sms_id: null,
    unreadCount: 0,
  }),
  computed: {
    ...mapGetters({
      smses: 'smses/getSmsList',
      getLastSms: 'smses/getLastSms',
    }),
    active() {
      //this.is_read = true;
      return this.index === this.uuid;
    },
    // currentSms() {
    //   if(this.index === this.uuid) {
    //     console.log("this.smses drom current", this.smses)
    //     let message = this.smses[0].text.slice(0, 31);
    //     let date = format(this.smses[0].created_on, 'DD MMM');
    //     return { message, date }
    //   } else {
    //     return {};
    //   }
    // }
    currentSms() {
      if(this.lastSms &&  this.index === this.uuid) {
        let message = this.lastSms.text.slice(0, 31);
        let date = format(this.lastSms.created_on, 'DD MMM');
        return { message, date}
      } else {
        return { message: null, date: null}
      }
    }
  },
  async created() {
    console.log("this.uuid", this.uuid)
    await this.init(); 
  },
  methods: {
    ...mapActions({
      viewSmses: 'smses/getSmsList',
      changeUreadCount: 'smses/updateUreadCount',
    }),
    makeSmsRead(id) {
      // this.$store.dispatch("EditSms", { id, sms: { is_read: 'true' } });
    },
    init:async function() {
      await this.viewSmses({ recipient_uuid: this.uuid });

      if(this.smses.length === 0) {
        this.date = '';
        this.message = '';
        return
      } 

      if (this.smses[0]) {
        this.last_sms_id = this.smses[0].sms_uuid;

        if(!this.smses[0].sent) {
          this.is_read = this.smses[0].is_read;
          if(!this.is_read) {
            
            console.log(`this.is_read- ${this.is_read}`)
            this.changeUreadCount(1);
          }
        }
        
        this.date = format(this.smses[0].created_on, 'DD MMM');

        this.message = this.smses[0].text.slice(0, 31);
      } 
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  .active {
    background: #f0f1fa;
  }
  .item {
    height: 74px;
    width: 100%;
    display: flex;
    .avatar {
      height: 31px;
      width: 31px;
      margin-left: 15px;
      margin-top: 12px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #eceef0;
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 1px;
      line-height: 15px;
      text-align: center;
    }
    .info-container {
      margin-top: 12px;
      margin-left: 8px;
      width: 233px;
      .user-info {
        height: 25px;
        display: flex;
        justify-content: space-between;
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        .date {
          font-family: ""Helvetica Neue"";
        }
      }
      .user-message {
        height: 25px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
      }
      .phone-number {
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        margin-bottom: 0;
      }
    }
    .bold {
      font-weight: 1000;
    }
  }
  .item:hover {
    background-color: #f0f1fa;
  }
}
</style>
